import { sva } from "@agapi/ui/panda/css";

export const cartItemListStyles = sva({
  slots: ['root'],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "tight",
      pt: "3",
      px: "4",
    }
  }
});
